// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"9178a8da","288":"4d3ef6bb","307":"e440016f","344":"dda931db","368":"296b44dc","410":"8a068ef6","647":"e74ac8e2","674":"9ddc757a","681":"0de4d782","795":"98e75e06","907":"97da5524","951":"1cf5b74b"}[chunkId] + ".chunk.js";
};